<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>Détails du service "{{name}}"</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="text-center mb-3">
          <b-image class="mb-1 logo" :src="logo"/>
          <br/>
          <d-link :href="home_page_url" target="_blank">
            Page d'accueil du service <i class="fa fa-external-link-alt"></i>
          </d-link>
        </div>
        <d-form-row>
          <d-col cols="6" class="pr-3 border-right">
            <c-input type="color" container-class="mb-3" label="Couleur du service" :value="color" disabled>
              Veuillez entrer une couleur
            </c-input>
            <c-input container-class="mb-3" label="Propriétaire" :value="owner" disabled/>
            <c-input container-class="mb-3" label="Nom du service" :value="name" disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Solde du service" :value="balance"
                     disabled/>
            <c-input container-class="mb-3" label="ID d'application" :value="application_id" disabled/>
            <c-input container-class="mb-3" label="Clé publique" :value="public_key" disabled/>
            <c-input container-class="mb-3" label="E-mail de notification" :value="notify_email" disabled/>
            <c-input type="date" container-class="mb-3" label="Date de création" :value="created_at" disabled/>
            <c-input type="textarea" container-class="mb-3" label="Description" :value="description" disabled/>
            <c-input type="textarea" container-class="mb-3" label="Certificat public"
                     v-model="signing_certificate" :state="signing_certificate_state" :disabled="!is_editable">
              Veuillez entrer un certificat public valide
            </c-input>
          </d-col>
          <d-col cols="6" class="pl-3">
            <c-input type="price" currency="%" container-class="mb-3"
                     label="Pourcentage des commissions supportées par le client"
                     v-model="customer_commissions_percent" :state="customer_commissions_state"
                     :disabled="!is_editable">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3"
                     label="Pourcentage des frais supportés par le client"
                     v-model="customer_fees_percent" :state="customer_fees_state" :disabled="!is_editable">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <b-form-group>
              <label class="font-weight-bold mb-0">URL de succès</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="success_url" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <d-link class="btn btn-info" :href="success_url" target="_blank" :disabled="!has_success_url">
                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir
                  </d-link>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
            <b-form-group>
              <label class="font-weight-bold mb-0">URL d'échec</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="error_url" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <d-link class="btn btn-info" :href="error_url" target="_blank" :disabled="!has_error_url">
                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir
                  </d-link>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
            <b-form-group>
              <label class="font-weight-bold mb-0">URL d'annulation</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="cancel_url" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <d-link class="btn btn-info" :href="cancel_url" target="_blank" :disabled="!has_cancel_url">
                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir
                  </d-link>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
            <b-form-group>
              <label class="font-weight-bold mb-0">URL de la callback</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="notify_url" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <d-link class="btn btn-info" :href="notify_url" target="_blank" :disabled="!has_notify_url">
                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir
                  </d-link>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
            <c-input container-class="mb-3" label="Adresses IP autorisées (séparateur: , )" v-model="authorized_ip"
                     :state="authorized_ip_state" :disabled="!is_editable">
              Veuillez saisir * ou les adresses IP séparées par des virgules
            </c-input>
            <c-input container-class="mb-3" label="Adresses email d'information (séparateur: , )"
                     v-model="dashboard_notify_emails" :state="dashboard_notify_emails_state" :disabled="!is_editable">
              Laisser vide ou saisir les adresses email séparées par des virgules
            </c-input>
            <d-form-checkbox class="mb-3" v-model="display_secured_by" :disabled="!is_editable">
              Afficher le partenaire de sécurité
            </d-form-checkbox>
            <d-form-checkbox class="mb-3" v-model="display_fees" :disabled="!is_editable">
              Afficher les frais au client
            </d-form-checkbox>
            <d-form-checkbox class="mb-3" v-model="enabled" :disabled="!is_editable">
              Service actif
            </d-form-checkbox>
            <d-form-checkbox class="mb-3" v-model="withdrawal_enabled" :disabled="!is_editable">
              Retrait autorisé
            </d-form-checkbox>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit"
                          v-if="is_editable && !selectedItem.deleted">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <c-button-spinner variant="danger" :fetching="fetchingDelete" @click="onDeleteService"
                          v-if="can_edit_withholding && !selectedItem.deleted">
          <template slot="icon">
            <i class="fa fa-trash"></i>
          </template>
          Supprimer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-modal v-if="settingsModalVisible" size="lg" @close="onSettingsModalClose">
      <d-modal-header>
        <d-modal-title>Paramètres du service "{{name}}"</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="text-center mb-3">
          <b-image class="mb-1 logo" :src="logo"/>
          <br/>
          <d-link :href="home_page_url" target="_blank">
            Page d'accueil du service <i class="fa fa-external-link-alt"></i>
          </d-link>
        </div>
        <table class="table table-borderless">
          <thead>
          <tr>
            <th>Actif</th>
            <th>Op.</th>
            <th>Com. vente (%)</th>
            <th>Frais vente</th>
            <th>Com. retrait (%)</th>
            <th>Frais retrait</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(operator_options, i) in operators_options" :key="operator_options.id">
            <td>
              <d-form-checkbox v-model="operator_options.operator_enabled" :disabled="!is_editable"/>
            </td>
            <td>
              <b-image class="table-logo" :src="operator_options.operator_logo"/>
            </td>
            <td>
              <c-input type="number" v-model="operator_options.payment_rate" :state="payment_rate_states[i]"
                       :disabled="!is_editable"/>
            </td>
            <td>
              <c-input type="number" v-model="operator_options.payment_fees" :state="payment_fees_states[i]"
                       :disabled="!is_editable"/>
            </td>
            <td>
              <c-input type="number" v-model="operator_options.withdrawal_rate" :state="withdrawal_rate_states[i]"
                       :disabled="!is_editable"/>
            </td>
            <td>
              <c-input type="number" v-model="operator_options.withdrawal_fees" :state="withdrawal_fees_states[i]"
                       :disabled="!is_editable"/>
            </td>
            <td>
              <c-button-spinner
                title="Enregistrer" class="d-flex" variant="success" :fetching="operator_options.fetchingSubmit"
                @click="() => onSettingsSubmit(operator_options)" v-d-tooltip.hover v-if="is_editable"
              >
                <template slot="icon">
                  <i class="fa fa-save"></i>
                </template>
              </c-button-spinner>
            </td>
          </tr>
          </tbody>
        </table>
      </d-modal-body>
    </d-modal>
    <d-modal v-if="exportModalVisible" size="lg" @close="onExportModalClose">
      <d-modal-header>
        <d-modal-title>Exporter les transactions du service</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <d-form-row>
          <d-col cols="6" class="pr-3 border-right">
            <c-input label="Nom du service" :value="name" disabled/>
            <c-input type="select" label="Format d'export" :options="exportFormatOptions" v-model="export_format"/>
            <c-input type="select" label="Séparateur" :options="exportDelimiterOptions" v-model="export_delimiter"/>
            <c-input
              type="filename" label="Nom du fichier" placeholder="Nom du fichier"
              v-model="export_filename" :extension="export_extension" :state="export_filename_state"
            >
              Veuillez saisir un nom de fichier valide
            </c-input>
          </d-col>
          <d-col cols="6" class="pl-3">
            <c-input type="select" label="Transactions à exporter" :options="exportTransactionTypeOptions"
                     v-model="export_transaction_type"/>
            <c-input type="select" label="Statuts à exporter" :options="exportTransactionStatusOptions"
                     v-model="export_transaction_status"/>
            <c-input type="datetime" label="Depuis le (inclus)" v-model="export_from_datetime"
                     :state="export_from_datetime_state">
              Veuillez entrer la date et l'heure de début
            </c-input>
            <c-input type="datetime" label="Jusqu'au (inclus)" v-model="export_to_datetime"
                     :state="export_to_datetime_state">
              Veuillez entrer la date et l'heure de fin
            </c-input>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onExportFormSubmit"
                          v-if="!selectedItem.deleted">
          <template slot="icon">
            <i class="fa fa-download"></i>
          </template>
          Télécharger
        </c-button-spinner>
        <b-button variant="secondary" @click="onExportModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
        <vue-json-csv
          ref="csv" :data="export_data" :name="export_filename + export_extension"
          :delimiter="export_delimiter"
        >
          <span></span>
        </vue-json-csv>
      </d-modal-footer>
    </d-modal>
    <d-modal v-if="staffModalVisible" size="lg" @close="onStaffModalClose">
      <d-modal-header>
        <d-modal-title>Personnel du service {{ name }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <c-table :fetching="fetchingStaff" :table-data="staffTableData" :fields="staffTableFields" :per-page="5">
          <p class="text-center" slot="empty">Aucun membre ajouté.</p>
        </c-table>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <b-button variant="secondary" @click="onStaffModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-modal v-if="withholdingModalVisible" size="lg" @close="onWithholdingModalClose">
      <d-modal-header>
        <d-modal-title>Retenues sur le service {{ name }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div v-if="fetchingWithholding" class="text-center">
          <b-spinner></b-spinner>
          <br>
          Chargement des données...
        </div>
        <table v-else-if="withholdingTaxes.length" class="table table-borderless">
          <thead>
          <tr>
            <th>Actif</th>
            <th>Nom</th>
            <th>Taux (%)</th>
            <th>Frais (FCFA)</th>
            <th>Solde (FCFA)</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(tax, i) in withholdingTaxes" :key="tax.id">
            <td>
              <d-form-checkbox v-model="tax.enabled"/>
            </td>
            <td>
              <c-input type="text" v-model="tax.name" :state="withholding_name_states[i]"/>
            </td>
            <td>
              <c-input type="number" v-model="tax.rate" :state="withholding_rate_states[i]" :step="0.01"/>
            </td>
            <td>
              <c-input type="number" v-model="tax.fees" :state="withholding_fees_states[i]"/>
            </td>
            <td>
              <c-input type="text" v-model="tax.balance" :disabled="true"/>
            </td>
            <td class="d-flex">
              <c-button-spinner
                title="Enregistrer" class="d-flex" variant="success" :fetching="tax.fetchingSubmit"
                @click="() => onWithholdingSubmit(tax, i)" v-d-tooltip.hover
              >
                <template slot="icon">
                  <i class="fa fa-save"></i>
                </template>
              </c-button-spinner>
              <b-button
                v-if="!tax.id" title="Supprimer" variant="danger" class="ml-1"
                @click="() => onWithholdingRemove(tax, i)" v-d-tooltip.hover
              >
                <i class="fa fa-trash"></i>
              </b-button>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-else class="text-center">
          <i class="fa fa-info-circle" style="font-size: 2rem"></i>
          <br>
          Aucune retenue trouvée.
        </div>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <b-button v-if="can_edit_withholding" variant="primary" @click="onWithholdingAdd">
          <i class="fa fa-plus"></i> Ajouter une retenue
        </b-button>
        <b-button variant="secondary" @click="onWithholdingModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4 pb-0">
        <d-input-group class="justify-content-center">
          <c-input class="w-25" placeholder="Rechercher par nom ou clé publique..." v-model="search"></c-input>
          <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetchingSearch"
                            @click="onSearchSubmit">
            <template slot="icon">
              <i class="fa fa-search"></i>
            </template>
            Rechercher
          </c-button-spinner>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="25">
          <p class="text-center" slot="empty">Aucun service trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import VueJsonCsv from "vue-json-csv"
import {Api, asset, DateFormatter, formatAmount, getFilename, Regex, Toast, truncate, truncateLeft} from "@/helpers"

export default {
  title: "Gestion des services marchand",
  components: {VueJsonCsv},
  data() {
    return {
      search: "",
      fetchingSearch: false,

      fetchingData: false,
      data: [],

      customer_fees_percent: "",
      customer_commissions_percent: "",

      //table header
      fields: [
        {key: "logo", label: "Logo"},
        {key: "name_pretty", label: "Nom du service", sortable: true},
        {key: "application_id_pretty", label: "ID d'application", sortable: true},
        // {key: "public_key_pretty", label: "Clé publique", sortable: true},
        {key: "signing_certificate_pretty", label: "Certificat", sortable: true},
        {key: "balance_pretty", label: "Solde", sortable: true},
        {key: "created_at_pretty", label: "Créé le", sortable: true},
        // {key: 'last_transaction_at_pretty', label: 'Dernière trans.', sortable: true},
        {key: "status", label: "Statut", sortable: true},
        {key: "actions", label: "Actions"},
      ],

      actions: [
        {
          type: "white",
          icon: "fas fa-exchange-alt",
          title: "Transactions du service",
          handler: this.onRedirectToTransaction
        },
        {type: "white", icon: "fa fa-file-excel", title: "Exporter les transactions", handler: this.onItemExport},
        {type: "white", icon: "fa fa-users", title: "Personnel", handler: this.onItemStaff},
        {type: "white", icon: "fa fa-cut", title: "Retenues", handler: this.onItemWithholding},
        {type: "white", icon: "fa fa-cog", title: "Paramètres", handler: this.onItemSettings},
        {type: "white", icon: "fa fa-ellipsis-h", title: "Détails du service", handler: this.onItemSelect},
      ],

      selectedItem: null,

      modalVisible: false,
      document_expire_date: "",
      enabled: false,
      withdrawal_enabled: false,
      authorized_ip: "",
      dashboard_notify_emails: "",
      signing_certificate: "",
      display_fees: true,
      display_secured_by: true,

      settingsModalVisible: false,
      operators_options: [],

      exportModalVisible: false,
      export_data: [],
      export_transaction_type: "PAYIN",
      export_transaction_status: "SUCCESS",
      export_from_datetime: DateFormatter.todayStart(),
      export_to_datetime: DateFormatter.todayEnd(),
      export_format: "CSV",
      export_delimiter: ";",
      export_filename: "",

      staffModalVisible: false,
      fetchingStaff: false,
      staffTableData: [],
      staffTableFields: [
        {key: "name", label: "Nom", sortable: true},
        {key: "role", label: "Rôle", sortable: true},
        {key: "created_at_pretty", label: "Ajouté le", sortable: true},
        {key: "status", label: "Statut", sortable: true},
      ],

      withholdingModalVisible: false,
      fetchingWithholding: false,
      withholdingTaxes: [],

      submitted: false,
      fetchingFormSubmit: false,
      fetchingDelete: false
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        return item.name.toLowerCase().includes(search)
          || item.application_id.includes(search)
          || item.public_key.includes(search)
          || item.user.first_name.includes(search)
          || item.user.last_name.includes(search)
      })
    },
    itemSelected() {
      return !!this.selectedItem
    },
    is_editable() {
      return this.auth.isOpManager() || this.auth.isHelpDesk()
    },
    can_edit_withholding() {
      return this.auth.isOpManager()
    },
    logo() {
      return this.itemSelected ? this.selectedItem.logo : ""
    },
    home_page_url() {
      return this.itemSelected ? this.selectedItem.home_page_url : ""
    },
    owner() {
      return this.itemSelected ? this.selectedItem.user.first_name + " " + this.selectedItem.user.last_name : ""
    },
    name() {
      return this.itemSelected ? this.selectedItem.name : ""
    },
    application_id() {
      return this.itemSelected ? this.selectedItem.application_id : ""
    },
    public_key() {
      return this.itemSelected ? this.selectedItem.public_key : ""
    },
    notify_email() {
      return this.itemSelected ? this.selectedItem.notify_email : ""
    },
    created_at() {
      return this.itemSelected ? this.selectedItem.created_at : ""
    },
    description() {
      return this.itemSelected ? this.selectedItem.description : ""
    },
    balance() {
      return this.itemSelected ? this.selectedItem.balance : ""
    },
    color() {
      return this.itemSelected ? this.selectedItem.color : ""
    },
    has_document() {
      return this.itemSelected && this.selectedItem.document_zip_path
    },
    document_zip_path() {
      return this.has_document
        ? truncateLeft(getFilename(this.selectedItem.document_zip_path), 32)
        : "-- Aucun fichier --"
    },
    has_success_url() {
      return this.itemSelected && this.selectedItem.success_url
    },
    success_url() {
      return this.has_success_url ? this.selectedItem.success_url : "-- Aucun fichier --"
    },
    has_error_url() {
      return this.itemSelected && this.selectedItem.error_url
    },
    error_url() {
      return this.has_error_url ? this.selectedItem.error_url : "-- Aucun fichier --"
    },
    has_cancel_url() {
      return this.itemSelected && this.selectedItem.cancel_url
    },
    cancel_url() {
      return this.has_cancel_url ? this.selectedItem.cancel_url : "-- Aucun fichier --"
    },
    has_notify_url() {
      return this.itemSelected && this.selectedItem.notify_url
    },
    notify_url() {
      return this.has_notify_url ? this.selectedItem.notify_url : "-- Aucun fichier --"
    },

    payment_rate_states() {
      return this.operators_options.map(el => !el.submitted || Regex.isValidRate(el.payment_rate))
    },
    payment_fees_states() {
      return this.operators_options.map(el => !el.submitted || Regex.isPositiveNumber(el.payment_fees))
    },
    withdrawal_rate_states() {
      return this.operators_options.map(el => !el.submitted || Regex.isValidRate(el.withdrawal_rate))
    },
    withdrawal_fees_states() {
      return this.operators_options.map(el => !el.submitted || Regex.isPositiveNumber(el.withdrawal_fees))
    },

    customer_commissions_state() {
      return !this.submitted || Regex.isValidRate(this.customer_commissions_percent)
    },
    customer_fees_state() {
      return !this.submitted || Regex.isValidRate(this.customer_fees_percent)
    },
    authorized_ip_state() {
      return !this.submitted || this.authorized_ip === "*" || Regex.isValidIpList(this.authorized_ip)
    },
    dashboard_notify_emails_state() {
      return !this.submitted || Regex.isEmptyOrEmailList(this.dashboard_notify_emails)
    },
    signing_certificate_state() {
      return !this.submitted || Regex.isEmptyOrValidCertificate(this.signing_certificate)
    },

    exportFormatOptions() {
      return [{text: "CSV", value: "CSV"}]
    },
    exportDelimiterOptions() {
      return [{text: ";", value: ";"}, {text: ",", value: ","}]
    },
    exportTransactionTypeOptions() {
      return [{text: "Paiements entrants", value: "PAYIN"}, {text: "Paiements sortants", value: "PAYOUT"}]
    },
    exportTransactionStatusOptions() {
      return [
        {text: "Tous les statuts", value: "ALL"},
        {text: "Transactions réussies", value: "SUCCESS"},
        {text: "Transactions échoués", value: "FAILED"}
      ]
    },
    export_from_datetime_state() {
      return !this.submitted || Regex.isDatetime(this.export_from_datetime)
    },
    export_to_datetime_state() {
      return !this.submitted || Regex.isDatetime(this.export_to_datetime)
    },
    export_filename_state() {
      return !this.submitted || Regex.isValidFilename(this.export_filename)
    },
    export_extension() {
      return ".csv"
    },

    withholding_rate_states() {
      return this.withholdingTaxes.map(el => !el.submitted || Regex.isValidRate(el.rate))
    },
    withholding_fees_states() {
      return this.withholdingTaxes.map(el => !el.submitted || Regex.isPositiveInteger(el.fees))
    },
    withholding_name_states() {
      return this.withholdingTaxes.map(el => !el.submitted || Regex.isNotBlank(el.name))
    },
  },
  created() {
    this.fetchingData = true
    Api.get("/service/list")
      .then(res => this.data = res.data.services.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    onOpenIDFile(link) {
      window.open(link, "_blank")
    },
    mapItem(item) {
      return {
        ...item,
        name_pretty: truncate(item.name, 40),
        application_id_pretty: truncate(item.application_id, 15),
        public_key_pretty: truncate(item.public_key, 15),
        signing_certificate_pretty: item.signing_certificate ? "Certificat ✔" : "Certificat 🚫",
        logo: item.logo,
        balance_pretty: formatAmount(item.balance),
        created_at_pretty: item.created_at,
        _rowVariant: item.deleted === true ? "secondary" : "",
        last_transaction_at_pretty: (item.last_transaction_at || "---").replace(" ", "\n"),
        status: item.enabled ? "Actif" : item.identity_file ? "En attente..." : "Inactif",
        statusVariant: item.enabled ? "success" : item.identity_file ? "warning" : "secondary",
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.enabled = item.enabled
      this.withdrawal_enabled = item.withdrawal_enabled
      this.document_expire_date = item.document_expire_date
      this.operators_options = item.service_operator_options.map(el => ({
        ...el,
        operator_logo: asset(el.operator.logo),
        submitted: false,
        fetchingSubmit: false,
      }))
      this.authorized_ip = item.authorized_ip
      this.dashboard_notify_emails = item.dashboard_notify_emails
      this.signing_certificate = item.signing_certificate
      this.display_fees = item.display_fees
      this.display_secured_by = item.display_secured_by
      this.modalVisible = true
      this.customer_commissions_percent = item.customer_commissions_percent
      this.customer_fees_percent = item.customer_fees_percent
    },
    clearFields() {
      this.enabled = false
      this.withdrawal_enabled = false
      this.document_expire_date = ""
      this.operators_options = []
      this.authorized_ip = ""
      this.dashboard_notify_emails = ""
      this.signing_certificate = ""
      this.display_fees = true
      this.display_secured_by = true
      this.customer_commissions_percent = ""
      this.customer_fees_percent = ""
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearFields()
    },
    onItemSettings(item) {
      this.selectedItem = item
      this.operators_options = item.service_operator_options.map(el => ({
        ...el,
        operator_logo: asset(el.operator.logo),
        submitted: false,
        fetchingSubmit: false,
      }))
      this.settingsModalVisible = true
    },
    clearSettingsFields() {
      this.operators_options = []
    },
    onSettingsModalClose() {
      this.settingsModalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearSettingsFields()
    },
    isFormValid() {
      return (this.authorized_ip === "*" || Regex.isValidIpList(this.authorized_ip))
        && Regex.isEmptyOrEmailList(this.dashboard_notify_emails)
        && Regex.isEmptyOrValidCertificate(this.signing_certificate)
        && Regex.isValidRate(this.customer_commissions_percent)
        && Regex.isValidRate(this.customer_fees_percent)
    },
    onFormSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      this.fetchingFormSubmit = true
      Api.postFormData("/service/update", {
        service_id: this.selectedItem.id,
        document_expire_date: this.document_expire_date,
        enabled: this.enabled,
        withdrawal_enabled: this.withdrawal_enabled,
        authorized_ip: this.authorized_ip,
        dashboard_notify_emails: this.dashboard_notify_emails,
        signing_certificate: this.signing_certificate,
        display_fees: this.display_fees,
        display_secured_by: this.display_secured_by,
        customer_commissions_percent: this.customer_commissions_percent,
        customer_fees_percent: this.customer_fees_percent
      })
        .then(res => {
          const service = this.mapItem(res.data.service)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, service)

          this.onModalClose()

          Toast.success(`Le service "${service.name}" a été mis à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },

    areSettingsValid(operator_options) {
      return Regex.isValidRate(operator_options.payment_rate)
        && Regex.isPositiveNumber(operator_options.payment_fees)
        && Regex.isValidRate(operator_options.withdrawal_rate)
        && Regex.isPositiveNumber(operator_options.withdrawal_fees)
    },
    onSettingsSubmit(operator_options) {
      operator_options.submitted = true

      if (!this.areSettingsValid(operator_options)) return

      operator_options.fetchingSubmit = true
      Api.postFormData("/service/options/update", {
        service_operator_option_id: operator_options.id,
        payment_rate: operator_options.payment_rate,
        payment_fees: operator_options.payment_fees,
        withdrawal_rate: operator_options.withdrawal_rate,
        withdrawal_fees: operator_options.withdrawal_fees,
        operator_enabled: operator_options.operator_enabled,
      })
        .then(res => {
          const service_operator_option = res.data.service_operator_option
          this.selectedItem.service_operator_options = this.selectedItem.service_operator_options
            .replaceOne(item => item.id === operator_options.id, service_operator_option)

          Toast.success(`Les paramètres de l'opérateur ${operator_options.operator.name} on été mis à jour avec succès pour le service "${this.selectedItem.name}" !`)
        })
        .catch(err => this.error = err)
        .then(() => operator_options.fetchingSubmit = false)
    },
    onSearchSubmit() {
      this.fetchingSearch = true
      Api.postFormData("/service/find", {search: this.search})
        .then(res => this.data = res.data.services.map(this.mapItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },

    //redirect a raising to its transactions
    onRedirectToTransaction(item) {
      this.$router.push({name: "transactions", query: {entity: "SERVICE", id: item.id}})
    },

    onDeleteService() {
      const text = prompt(`Veuillez saisir "DELETE" pour supprimer le service ${this.selectedItem.name} appartenant à ${this.selectedItem.user.last_name} ${this.selectedItem.user.first_name}`)
      if (text !== "DELETE") return

      this.fetchingDelete = true
      Api.postFormData("/service/delete", {
        service_id: this.selectedItem.id,
      })
        .then(res => {
          const service = res.data.service
          this.data = this.data.filter(item => item.id !== this.selectedItem.id)

          this.onModalClose()

          Toast.success(`Le service "${service.name} a été supprimé avec succès`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingDelete = false)
    },

    onItemExport(item) {
      this.selectedItem = item
      this.export_filename = `Campost-Payment_Dump_${item.name.replace(/\W+/g, "-")}_${DateFormatter.raw()}`
      this.exportModalVisible = true
    },
    clearExportFields() {
      this.export_data = []
      this.export_transaction_type = "PAYIN"
      this.export_transaction_status = "SUCCESS"
      this.export_from_datetime = DateFormatter.todayStart()
      this.export_to_datetime = DateFormatter.todayEnd()
      this.export_format = "CSV"
      this.export_delimiter = ";"
      this.export_filename = ""
    },
    onExportModalClose() {
      this.exportModalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearExportFields()
    },
    isExportFormValid() {
      return Regex.isDatetime(this.export_from_datetime)
        && Regex.isDatetime(this.export_to_datetime)
        && Regex.isValidFilename(this.export_filename)
    },
    onExportFormSubmit() {
      this.submitted = true

      if (!this.isExportFormValid()) return

      this.fetchingFormSubmit = true
      Api.postFormData("/service/dump", {
        service_id: this.selectedItem.id,
        transaction_type: this.export_transaction_type,
        transaction_status: this.export_transaction_status,
        from_datetime: this.export_from_datetime,
        to_datetime: this.export_to_datetime,
        format: this.export_format,
        separator: this.export_delimiter,
      })
        .then(res => {
          this.export_data = res.data.transactions
          if (!this.export_data.length)
            Toast.info("Aucune transaction trouvée")
          else {
            Toast.loading(`Génération du fichier ${this.export_format}...`)
            setTimeout(() => {
              Toast.loadingToast.goAway()
              this.$refs.csv.generate()
            }, 2000)
          }
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },

    mapStaffItem(item) {
      return {
        ...item,
        name: `${item.user.name}\n(${item.user.username})`,
        role: item.right.name,
        status: item.deleted ? "Supprimé" : "Actif",
        statusVariant: item.deleted ? "danger" : "success",
        created_at_pretty: item.created_at.replace(" ", "\n"),
      }
    },
    onItemStaff(item) {
      this.selectedItem = item
      this.staffModalVisible = true

      this.fetchingStaff = true
      Api.get("/service/staff", {service_id: item.id})
        .then(res => this.staffTableData = res.data.staff.map(this.mapStaffItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingStaff = false)
    },
    clearStaffFields() {
      this.staffTableData = []
    },
    onStaffModalClose() {
      this.staffModalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearStaffFields()
    },

    onItemWithholding(item) {
      this.selectedItem = item
      this.withholdingModalVisible = true

      this.fetchingWithholding = true
      Api.get("/service/withholding", {service_id: item.id})
        .then(res => this.withholdingTaxes = res.data.withholdings.map(this.mapWithholdingItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingWithholding = false)
    },
    mapWithholdingItem(item) {
      return {...item, submitted: false, fetchingSubmit: false}
    },
    clearWithholdingFields() {
      this.withholdingTaxes = []
    },
    onWithholdingModalClose() {
      this.withholdingModalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearWithholdingFields()
    },
    isWithholdingValid(tax) {
      return Regex.isValidRate(tax.rate)
        && Regex.isPositiveNumber(tax.fees)
        && Regex.isNotBlank(tax.name)
    },
    onWithholdingAdd() {
      this.withholdingTaxes.push(
        this.mapWithholdingItem({enabled: true, name: "", fees: 0, rate: 0, description: "", balance: 0})
      )
    },
    onWithholdingRemove(tax, i) {
      this.withholdingTaxes.splice(i, 1)
    },
    onWithholdingSubmit(tax, i) {
      tax.submitted = true

      if (!this.isWithholdingValid(tax)) return

      tax.fetchingSubmit = true
      if (tax.id)
        Api.postFormData("/service/withholding/update", {
          withholding_id: tax.id,
          enabled: tax.enabled,
          name: tax.name,
          rate: tax.rate,
          fees: tax.fees,
          description: tax.description,
        })
          .then(res => {
            const withholding = res.data.withholding

            Toast.success(`La retenue ${withholding.name} a été mise à jour avec succès sur le service ${this.selectedItem.name} !`)
          })
          .catch(err => this.error = err)
          .then(() => tax.fetchingSubmit = false)
      else
        Api.postFormData("/service/withholding/create", {
          service_id: this.selectedItem.id,
          enabled: tax.enabled,
          name: tax.name,
          rate: tax.rate,
          fees: tax.fees,
          description: tax.description,
        })
          .then(res => {
            const withholding = res.data.withholding
            tax.id = withholding.id

            Toast.success(`La retenue ${withholding.name} a été créée avec succès sur le service ${this.selectedItem.name} !`)
          })
          .catch(err => this.error = err)
          .then(() => tax.fetchingSubmit = false)
    },
  }
}
</script>

<style scoped>
.logo {
  max-height: 50px;
}

.table-logo {
  max-height: 24px;
  max-width: 100%;
}

.table tr td label, .table tr td .form-group {
  margin: 0;
}
</style>
